export function optimisedImage(src?: string, size?: 'small' | 'medium'): string {
  if (!src) return '';
  if (!size) return src;

  const extension = src.split('.').pop();

  if (extension !== 'webp') return src;

  const baseUrl = src.slice(0, -(extension?.length || 0) - 1);

  return `${baseUrl}_${size}.${extension}`;
}
